var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2536_86055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.74414 4.59884L12.1319 14.9934L8.82413 14.9936L1.75046 8.13508L1.74414 4.59884Z",
    stroke: "#2AB75A",
    strokeWidth: 1.41273
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.01205,
    cy: 7.23275,
    r: 0.92025,
    fill: "#2AB75A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.7406,
    cy: 4.75619,
    r: 0.92025,
    fill: "#2AB75A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.4691,
    cy: 2.27572,
    r: 0.92025,
    fill: "#2AB75A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2536_86055"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.816406 0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalIcon);
export default __webpack_public_path__ + "static/media/terminal_icon.eefb2f906a992d29f85d82ee1db830f4.svg";
export { ForwardRef as ReactComponent };